import { IAstOptions, transformToDSL as ITransformToDSL, transformTokensToDSL as ITransformTokensToDSL } from '../index.d';
import { IFqnToken, IToken } from '../typings/token';
import { getTokens } from '../token/get-special-token';


export const transformTokensToDSL: typeof ITransformTokensToDSL = (tokens: IToken[]) => {
  return tokens.map(token => {
    return token.type === 'FqnProperty' ? (token as IFqnToken).dsl : token.raw;
  }).join('');
};



export const transformToDSL: typeof ITransformToDSL = (input: string, options: IAstOptions) => {
  const { tokens } = getTokens(input, {
    ignoreWhiteSpace: false,
    declarations: options.declarations,
    fqn: options.fqn
  });
  return transformTokensToDSL(tokens);
};
